/**
 * Generated runtime TestId mirror for frontend/src/pages/ClusterNodes.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ClusterNodesTestIds = {
  clusterNodesCard: "cluster-nodes-card",
  colActions: "col-actions",
  colHostname: "col-hostname",
  colIpAddress: "col-ip-address",
  colLastHeartbeat: "col-last-heartbeat",
  colNodeId: "col-node-id",
  colRegistered: "col-registered",
  colStatus: "col-status",
  masterNodeId: "master-node-id",
  btnRemoveNode: (node_nodeId: string) => `btn-remove-node-${node_nodeId}`,
  btnRemoveNodePrefix: () => "btn-remove-node-" as TestIdPrefix,
  rowClusterNode: (node_nodeId: string) => `row-cluster-node-${node_nodeId}`,
  rowClusterNodePrefix: () => "row-cluster-node-" as TestIdPrefix
} as const;
